import { getNewsDetail, getNewsList } from 'actions/requests';
import dynamic from 'next/dynamic'
import classNames from 'classnames';
import Head from 'next/head';
import React from 'react';
import ContainerFluid from '../../component/ContainerFluid';
import Header from '../../component/Header/Header';
import styles from './News.module.scss'
import Footer from 'component/Footer'
import TopBanner from '../../component/Home/TopBanner'
import { motion } from 'framer-motion'
import Image from '../../component/ImgComponent';
import LoadingComponent from '../../component/Loading/index'
import { useRouter } from 'next/router';

const Editor = dynamic(() => import('./Editor'), { ssr: false, loading: () => <LoadingComponent /> })
import PopupComponent from './../../component/Popup/index';
import PopupForm from './../../component/Popup/PopupForm';

const NewsDetail = ({ data }) => {
  const { locale } = useRouter()
  return (
    <>
      <Head>
        <title>{data?.title}</title>
        <meta name="title" property="og:title" content={data?.title}></meta>
        <meta name="description" property="og:description" content={data?.short_content}></meta>
        <meta property="description" content={data?.short_content ?? "test description"}></meta>
        <link rel="prefetch" href="/static/vn-flag.png" />
        <link rel="prefetch" href="/static/uk-flag.png" />
        <meta name="viewport" content="width=device-width, height=device-height, initial-scale=1.0, user-scalable=0, minimum-scale=1.0, maximum-scale=1.0" />
        <meta name="image" property="og:image" content={`${process.env.NEXT_PUBLIC_MEDIA_FILE}${data?.images?.image}`}></meta>
        <meta property="og:image:secure_url" content={`${process.env.NEXT_PUBLIC_MEDIA_FILE}${data?.images?.image}`}></meta>
        <meta property="og:image:width" content="640" />
        <meta property="og:image:height" content="442" />
        <meta property="og:image:alt" content={`${data?.images?.alt_text}`}></meta>
        <meta property="og:type" content="website"></meta>
        <meta property="og:url" content={`https://estuary.solutions/${locale || "en"}/news/${data?.slug}`}></meta>
        <link rel="canonical" href={`https://estuary.solutions/${locale || "en"}/news/${data?.slug}`} />
        <link rel="shortcut icon" href={`${process.env.NEXT_PUBLIC_MEDIA_FILE}299c980f-d8d5-406e-8fe1-432221fa6896`} type="image/x-icon" />
        <meta name="keywords" content={data?.seo_info?.list?.length > 0 ? JSON.stringify(data.seo_info.list) : "Estuary Solutions"} />
      </Head>
      {
        !data
          ? <LoadingComponent />
          : data.error
            ? <p>Error</p>
            :
            <ContainerFluid className={[classNames("news-detail"), styles.news_detail]}>
              <Header />
              <PopupComponent locale={locale} name="popup_news_detail">
                <PopupForm locale={locale} />
              </PopupComponent>
              <div className="container-fluid">
                <div className="row">
                  <TopBanner
                    style={{
                      paddingTop: "100px"
                    }}
                    customHeight
                    contentClass="mt-0"
                    mode="fill"
                    actions="none"
                    title={
                      data?.title
                    }
                    description={
                      data?.short_content
                    }
                  >
                    <div className={classNames("col-12 col-md-6 text-center")}>
                      <motion.div
                        initial={{
                          opacity: 0,
                          scale: 0,
                          translateX: 200
                        }}
                        animate={{
                          opacity: 1,
                          scale: 1,
                          translateX: 0
                        }}
                        transition={{ duration: 0.5 }}
                      >
                        <Image
                          width={550}
                          height={240}
                          objectFit="contain"
                          src={process.env.NEXT_PUBLIC_MEDIA_FILE + data?.images?.image}
                          alt={data?.images?.alt_text}
                        // src="/static/article1-banner.png" 
                        />
                      </motion.div>
                    </div>
                  </TopBanner>
                </div>
              </div>
              {/* <div
                  className="container news-content mb-4 my-lg-5"
                  dangerouslySetInnerHTML={renderNewsContent(data?.content)}
                ></div> */}
              <Editor value={data?.content || ""} />
              <Footer className="mt-4" />
            </ContainerFluid>
      }
    </>
  );
};

export const getStaticPaths = async (params) => {
  const res = await getNewsList({
    lang_id: params.locale === "vi" ? 1 : 2,
    status: 1
  })
  const paths = res.data.data.map(item => {
    return {
      params: {
        slug: item.slug.slice(0, item.slug.length - 8) + item.id,
        locale: item.lang === 1 ? "vi" : "en"
      }
    }
  })
  return {
    paths,
    fallback: true
  }
}

export const getStaticProps = async ({ params }) => {
  let data;
  let id = params.slug.split("-").pop()
  try {
    const res = await getNewsDetail(id * 1)
    data = res.data
    data.slug = params.slug
  } catch (error) {
    data = { error }
  }
  if (!data || data.error) {
    return {
      notFound: true
    }
  }
  return {
    props: { data },
    revalidate: 1
  }
}

export default NewsDetail;